import { useMemo } from 'react'

import useMenusStore from 'src/stores/useMenusStore'
import { AppMenuSavedDashboardInterface } from 'src/types/AppMenuInterface'
import { findSubProductOnMenusFn } from 'src/utils/menuUtils'
import { sortDashboardsFn } from 'src/utils/sortDashboardUtils'
import useProductPage from './useProductPage'

const useCurrentSubProductDashboards = (): AppMenuSavedDashboardInterface[] => {
  const { code, product: productCode, program } = useProductPage()
  const menu = useMenusStore(m => m.menus)

  const subProductDashboards = useMemo(() => {
    const subProducts = findSubProductOnMenusFn({
      menus: menu,
      subProductCode: code,
      productCode,
    })

    if (!subProducts) return []

    const dashboards = sortDashboardsFn(
      (subProducts.dashboards || []).filter(d => !d.default_dashboard),
    )

    if (!program) return dashboards

    return dashboards.filter(d => d.program_id?.toString() === program?.toString())
  }, [code, productCode, program, menu])

  return subProductDashboards
}

export default useCurrentSubProductDashboards
